/** Strip oversized base64 from design options before persisting to the server. */
export function sanitizeDesignOptionsForSave(designOpts) {
  const { backgroundImageBase64, ...rest } = designOpts || {};
  const thumbLen = rest.backgroundImageThumb?.length || 0;
  let safeDesignOpts =
    thumbLen > 0 && thumbLen <= 60000
      ? rest
      : { ...rest, backgroundImageThumb: undefined };

  const probe = JSON.stringify({ designOptions: safeDesignOpts });
  if (probe.length > 60000 && safeDesignOpts.backgroundImageThumb) {
    safeDesignOpts = { ...safeDesignOpts, backgroundImageThumb: undefined };
  }
  return safeDesignOpts;
}

export const DESIGN_OPTIONS_STORAGE_PREFIX = "ai_menu_design_";

export function loadCachedDesignOptions(customerId) {
  if (!customerId) return null;
  try {
    const raw = localStorage.getItem(`${DESIGN_OPTIONS_STORAGE_PREFIX}${customerId}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function cacheDesignOptions(customerId, designOpts) {
  if (!customerId || !designOpts) return;
  try {
    const { backgroundImageBase64, ...rest } = designOpts;
    localStorage.setItem(
      `${DESIGN_OPTIONS_STORAGE_PREFIX}${customerId}`,
      JSON.stringify(rest),
    );
  } catch {
    // ignore quota errors
  }
}
